var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.multiselect,{staticClass:"multiselect-mid",attrs:{"options":_setup.clients,"select-label":"","deselect-label":"","label":"name","track-by":"name"},on:{"search-change":_setup.searchClients},model:{value:(_setup.client),callback:function ($$v) {_setup.client=$$v},expression:"client"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }